export default __webpack_public_path__ + "static/media/about-team-james-marsh.6c6bfb36.png";